import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const startEmotions = useStore((state) => state.startEmotions);
  const setStartEmotions = useStore((state) => state.setStartEmotions);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.startEmotions.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={startEmotions}
          onChange={(value) => {
            setStartEmotions(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'start-emotions',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Motivated"}>
            <span>💥</span> {t('onboarding.startEmotions.options.motivated')}
          </Option>
          <Option value={"Confident"}>
            <span>😌</span> {t('onboarding.startEmotions.options.confident')}
          </Option>
          <Option value={"Nervous"}>
            <span>😬</span> {t('onboarding.startEmotions.options.nervous')}
          </Option>
          <Option value={"Disappointed"}>
            <span>😞</span> {t('onboarding.startEmotions.options.disappointed')}
          </Option>
          <Option value={"Unmotivated"}>
            <span>💤</span> {t('onboarding.startEmotions.options.unmotivated')}
          </Option>
          <Option value={"Not sure"}>
            <span>🤷</span> {t('onboarding.startEmotions.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
